export const normalizeCountry = (list) => (
    list.map((item) => {
        return { label: `+${item.dial_code} (${item.code})`, value: item.dial_code }
    })
)

const getDefaultCountry = (list) => list.find((item) => item.code === 'PE') ?? list[0]

export const getCountryCode = (list, data) => {
    const countryResult = data?.results?.find(({ types }) => types?.includes('country'))
    const countryComponent = countryResult?.address_components?.find(({ types }) => types?.includes('country'))

    if (!countryComponent?.short_name) {
        return getDefaultCountry(list)
    }

    return list.find((item) => item.code === countryComponent.short_name) ?? getDefaultCountry(list)
}

export const getCountryDial = (list, data) => {
    return list.find((item) => item.dial_code === data) ?? getDefaultCountry(list)
}
